// it would be nice to get this from the API schema but we exclude the schema for the products endpoint
export type Product = {
  ao_flow_category: string;
  id: string;
  core_id: string;
  uuid?: string;
  name: string;
  exclusive_application_types: string[];
  category: string;
  public: boolean;
  display_order: number;
};

export const tabTypes = <const>["consumer", "business", "consumer_staff_led", "business_staff_led"];
export type AoType = (typeof tabTypes)[number];

export type ProductFormData = {
  product: {
    disclosures: any[];
  };
  errors: any;
};

export type Bundle = {
  is_business: boolean;
  is_active: boolean;
  name: string;
  uuid: string;
  products_ids: string[];
};
